/**
 * 计划管理
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
    async getFormDetail(keyId,deptOrUser) {//获取详情
        return request(api.plan.PLAN + "/" + keyId + "?deptOrUser=" + deptOrUser, METHOD.GET);
    },
    async deleteItem(keyId) {//获取详情
        return request(api.plan.PLAN + "/" + keyId, METHOD.DELETE);
    },
    async getCostList() {//关联客户下拉数据
        return request(api.plan.CLUE + '/getCostList', METHOD.GET);
    },
    async getCommCode() {//意向品牌 品系 品系下拉
        return request(api.plan.CLUE + '/getCommCode', METHOD.GET);
    },
    async activityType() {//意向品牌 品系 活动类型下拉
        return request(api.plan.ACTIVITYTYPE, METHOD.GET);
    },
    async saveFormDetail(result) {//保存或修改
        return request(api.plan.PLAN, METHOD.POST, result);
    },
    async upDateFormDetail(result) {//保存或修改
        return request(api.plan.PLAN, METHOD.PUT, result);
    },
    async saveProvideDetail(result) {//保存或修改 活动 下发
        return request(api.plan.PROVIDE, METHOD.POST, result);
    },
    async selection(params) {
        return request(api.client.SELECTION, METHOD.GET, params)
    },
    async downErrorFile(url) {
        return request(api.temp.FILE_PATH + 'error/' + url, METHOD.GET, {download: 1})
    },
    async rollbackClue(ids) {
        return request(api.clue.CLUEPOOL + '/rollbackClue?idList=' + ids, METHOD.GET)
    },
    async getEditData(result,deptOrUser) {
        return request(api.plan.FINISH + '/1/' + deptOrUser, METHOD.POST,result)
    },
    async popSelect() {
        return request(api.comm.DEPT + '/popSelect', METHOD.GET);
    },
}


export default {dataApi}